import React from 'react';

import BauxCopro from '../../components/Monitoring/BauxCopro/BauxCopro.module';

function BauxCoproView() {
  return (
    <BauxCopro />
  );
}

export default BauxCoproView; 